import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "../../shadcn/ui/tooltip";

import { CheckIcon } from "lucide-react";
import { PunchupVerifiedIcon } from "./icons";
import { cn } from "@punchup/utils/cn";

export default function PunchupVerifiedBadge({
  borderColor,
  className,
  size,
  withTooltip = false,
}: {
  borderColor?: string;
  className?: string;
  size?: number;
  withTooltip?: boolean;
}) {
  const icon = (
    <PunchupVerifiedIcon
      className={cn(
        !size && "w-[20px] md:w-[26px] h-[20px] md:h-[26px]",
        className
      )}
      height={size ?? 18}
      width={size ?? 18}
    />
  );

  const content = borderColor ? (
    <span
      className="inline-flex items-center justify-center rounded-full"
      style={{
        border: `2px solid ${borderColor}`,
        backgroundColor: borderColor,
        borderRadius: "50%",
      }}
    >
      {icon}
    </span>
  ) : (
    icon
  );

  if (withTooltip) {
    return (
      <TooltipProvider>
        <Tooltip delayDuration={250}>
          <TooltipTrigger asChild>{content}</TooltipTrigger>
          <TooltipContent className="flex items-center gap-x-2" side="right">
            <CheckIcon
              width={14}
              height={14}
              strokeWidth={3}
              className="text-green-600 rounded-xl"
            />
            <p className="text-sm font-medium">Punchup verified</p>
          </TooltipContent>
        </Tooltip>
      </TooltipProvider>
    );
  }

  return content;
}
